import React from "react";
import { SortIcon } from "@sscs/ui";
const COLUMN_LABEL = {
    grade: "Priority / # issues",
    file_name: "File name",
    file_path: "File path",
};
const Sort = ({ sortBy, column, index, onSortChange, }) => {
    return (React.createElement(SortIcon, { id: `sort-${column}-${index}`, activeSort: sortBy, property: column, name: COLUMN_LABEL[column], handleSort: onSortChange, startReverse: column === "grade" }));
};
export default Sort;
//# sourceMappingURL=Sort.js.map